import Model from "./Model.js";

/**
 * An `Auditor` is a person who certifies the accounting of a
 * company. An auditor does not necessarily have access to the
 * application and is thus disconnected from the `User` class.
 *
 * @param {string} [spec.name] - Name of the auditor.
 * @param {string} [spec.city] - City of the auditor.
 * @param {string} [spec.title] - Title of the auditor.
 * @param {string} [spec.registrationNumber] - RegistrationNumber of the auditor
 * (CVR in Danish).
 * @param {string} [spec.organizationNumber] - OrganizationNumber of the
 * auditor's company (MNE in Danish).
 */
export default class Auditor extends Model {
	constructor({
		name = "",
		title = "",
		city = "",
		registrationNumber = "",
		organizationNumber = "",
	} = {}) {
		super(...arguments);

		this._name = name;
		this._title = title;
		this._city = city;
		this._registrationNumber = registrationNumber;
		this._organizationNumber = organizationNumber;
	}

	getName() {
		return this._name;
	}

	setName(name) {
		this._name = name;
	}

	getTitle() {
		return this._title;
	}

	setTitle(title) {
		this._title = title;
	}

	getCity() {
		return this._city;
	}

	setCity(city) {
		this._city = city;
	}

	getRegistrationNumber() {
		return this._registrationNumber;
	}

	setRegistrationNumber(registrationNumber) {
		this._registrationNumber = registrationNumber;
	}

	getOrganizationNumber() {
		return this._organizationNumber;
	}

	setOrganizationNumber(organizationNumber) {
		this._organizationNumber = organizationNumber;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.name = this._name;
		properties.city = this._city;
		properties.title = this._title;
		properties.registrationNumber = this._registrationNumber;
		properties.organizationNumber = this._organizationNumber;

		return properties;
	}
}
